import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUpload = props => (
  <SvgIcon {...props} viewBox="0 0 36 39.999802">
    <path d="m9 17.778h6.75v22.222h4.5v-22.222h6.75l-9-8.8893-9 8.8893zm-9-17.778v4.4444h36v-4.4444h-36z" />
  </SvgIcon>
);

export default IconUpload;



// WEBPACK FOOTER //
// ./src/components/icons/IconUpload.js